import React, { useEffect, useState } from 'react';
import PageLayout from '../layouts/PageLayout';
import { Grid, Box } from '@mui/material';
import CustomCard2 from '../../components/cards/CustomCard2';
import PTApplicantTable2 from '../../components/Tables/PTApplicantTable2';
import { PTSelector } from '../../states/features/selectors';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { filter } from 'lodash';
import NoContent from '../../components/NoContent';
import { isEmpty } from 'lodash';
import PTApplicantTable from '../../components/Tables/PTApplicantTable';
import CountBadge from '../../components/CountBadge';
import { size } from 'lodash';
import ApplicantsSidebar from '../../components/sidebars/ApplicantsSidebar';

const TrainingApplicantsByStatus = () => {
    // ############ Const #######################
    const { status } = useParams();

    // ############ Comp state ##################
    const [applicants, setApplicants] = useState([]);

    // ############ Redux state ##################
    const { allPracticalTrainingApplicants } = useSelector(PTSelector);

    // ############## FUNC ###################
    const getApplicantsByStatus = () => {
        let trainingApplicants = [];
        if (status === 'pending') {
            trainingApplicants = filter(
                allPracticalTrainingApplicants,
                ({ appliedTraining }) => appliedTraining.status === 'pending',
            );
        }
        if (status === 'approved') {
            trainingApplicants = filter(
                allPracticalTrainingApplicants,
                ({ appliedTraining }) =>
                    appliedTraining.status === 'approved' &&
                    appliedTraining.onTrainingStatus === 'pending',
            );
        }
        if (status === 'on-training') {
            trainingApplicants = filter(
                allPracticalTrainingApplicants,
                ({ appliedTraining }) =>
                    appliedTraining.onTrainingStatus === 'on-training',
            );
        }
        if (status === 'completed') {
            trainingApplicants = filter(
                allPracticalTrainingApplicants,
                ({ appliedTraining }) =>
                    appliedTraining.onTrainingStatus === 'completed',
            );
        }
        setApplicants(trainingApplicants);
    };

    // ############### useEffect ###############
    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            getApplicantsByStatus();
        }

        return () => {
            isSubscribed = false;
        };
    }, [allPracticalTrainingApplicants]);

    return (
        <>
            <PageLayout
                head={
                    status === 'pending' || status === 'approved'
                        ? `${status} practical training applications`
                        : `${status} practical training students`
                }
                sidebar={<ApplicantsSidebar />}
            >
                <Grid container>
                    <Grid item sm={12} xs={12}>
                        <CustomCard2
                            head={
                                status === 'pending' || status === 'approved'
                                    ? `All ${status} applications`
                                    : `All ${status} students`
                            }
                            padding={0}
                            action={
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Box sx={{ ml: 1 }}>
                                        <CountBadge
                                            total={size(applicants)}
                                            item={
                                                status === 'pending' ||
                                                status === 'approved'
                                                    ? `${status}  applications`
                                                    : `${status}  students`
                                            }
                                        />
                                    </Box>
                                </Box>
                            }
                        >
                            {isEmpty(applicants) ? (
                                <>
                                    <NoContent
                                        height={'72vh'}
                                        message={
                                            status === 'pending' ||
                                            status === 'approved'
                                                ? `No ${status}  applications`
                                                : `No ${status} students`
                                        }
                                    />
                                </>
                            ) : status === 'pending' ||
                              status === 'approved' ? (
                                <PTApplicantTable
                                    height={'65vh'}
                                    applicants={applicants}
                                />
                            ) : (
                                <PTApplicantTable2
                                    height={'65vh'}
                                    applicants={applicants}
                                />
                            )}
                        </CustomCard2>
                    </Grid>
                </Grid>
            </PageLayout>
        </>
    );
};

export default TrainingApplicantsByStatus;
